import { defineComponent as _defineComponent } from 'vue';
import QuotaOption from './options/quota-option.vue';
import ModelOption from './options/model-option.vue';
import DoctypeOption from './options/doctype-option.vue';
import DateOption from './options/date-option.vue';
import { useAuth } from '@/plugins/auth';
export default /*#__PURE__*/_defineComponent({
  __name: 'wandh-panel',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var auth = useAuth();
    var plan = auth.user.labsWandhPlan;
    var quotaOption = ref();
    var doctypeOption = ref();
    var dateOption = ref();
    var isPlanValid = computed(function () {
      var _quotaOption$value$ha, _quotaOption$value;
      return (
        // プランが取得できている
        plan !== undefined && (// モデルに残り回数がある
        (_quotaOption$value$ha = (_quotaOption$value = quotaOption.value) === null || _quotaOption$value === void 0 ? void 0 : _quotaOption$value.hasRemainingQuota) !== null && _quotaOption$value$ha !== void 0 ? _quotaOption$value$ha : false)
      );
    });
    var isWandhFilterValid = computed(function () {
      var _doctypeOption$value$, _doctypeOption$value, _dateOption$value$isP, _dateOption$value;
      return isPlanValid && ((_doctypeOption$value$ = (_doctypeOption$value = doctypeOption.value) === null || _doctypeOption$value === void 0 ? void 0 : _doctypeOption$value.isDocumentTypeValid) !== null && _doctypeOption$value$ !== void 0 ? _doctypeOption$value$ : false) && ((_dateOption$value$isP = (_dateOption$value = dateOption.value) === null || _dateOption$value === void 0 ? void 0 : _dateOption$value.isPublishedOnOrAfterValid) !== null && _dateOption$value$isP !== void 0 ? _dateOption$value$isP : false);
    });
    expose({
      isWandhFilterValid: isWandhFilterValid
    });
    return {
      __sfc: true,
      auth: auth,
      plan: plan,
      quotaOption: quotaOption,
      doctypeOption: doctypeOption,
      dateOption: dateOption,
      isPlanValid: isPlanValid,
      isWandhFilterValid: isWandhFilterValid,
      QuotaOption: QuotaOption,
      ModelOption: ModelOption,
      DoctypeOption: DoctypeOption,
      DateOption: DateOption
    };
  }
});